import Vue from "vue";
class ScrollController {
  /**
   * Copyright (c) 2025 wcc
   * @param {Vue} tableRef - 表格Ref实例
   * @param {string} position - 滚动位置 top 顶部， bottom 底部.
   * @param {boolean} controlParent - 是否控制父元素（针对未设置高度的el-table）.
   * @constructor
   */
  constructor(tableRef, position = 'top', controlParent = false) {
    this.table = tableRef;
    this.position = position;
    this.controlParent = controlParent;
    this.scrollElement = this.findScrollElement();
  }

  // 查找可滚动容器
  findScrollElement() {
    // 控制父元素
    if (this.controlParent) {
      return this.findParentScrollElement();
    }

    // 1. 检查表格是否存在并包含$refs
    if (this.table && this.table.$refs) {
      const bodyWrapper = this.table.$refs.bodyWrapper;
      if (bodyWrapper) {
        return bodyWrapper;
      }
    }
    // 表格自身无滚动时，自动查找父元素
    return this.findParentScrollElement();
  }

  // 查找父级滚动容器
  findParentScrollElement() {
    if (!this.table || !this.table.$el) return null;

    let parent = this.table.$el.parentElement;
    while (parent && parent !== document.documentElement) {
      const style = window.getComputedStyle(parent);
      if (['auto', 'scroll'].includes(style.overflowY)) {
        return parent;
      }
      parent = parent.parentElement;
    }
    return null;
  }

  execute() {
    if (!this.scrollElement) {
      console.warn('未找到可滚动容器');
      return;
    }
    
    const scrollTop = this.position === 'top' 
      ? 0 
      : this.scrollElement.scrollHeight;

    if (this.scrollElement.scrollTo) {
      this.scrollElement.scrollTo({ top: scrollTop, behavior: 'instant' });
    } else {
      this.scrollElement.scrollTop = scrollTop;
    }
  }
}

// Vue全局方法
Vue.prototype.$scrollTable = function (tableRef, position, controlParent = false) {
  // const tableRef = this.$refs[refName];
  if (!tableRef) return;

  this.$nextTick(() => {
    const controller = new ScrollController(tableRef, position, controlParent);
    controller.execute();
  });
};


// WEBPACK FOOTER //
// ./src/utils/scrollTable.js